import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, merge, mergeMap, of, pipe, switchMap, take, tap } from "rxjs";
import * as RevisionStatusActions from "./actions";
import { AppNotificationService } from "src/app/shared/services/notification.service";
import { translate } from '@jsverse/transloco';
import { IRevision } from "src/app/revisions/models/revision";
import { RevisionStatusService } from "src/app/revisions/services/revision-status.service";
import { IGetRevisionStatusResponse } from "src/app/revisions/models/revision-status";

@Injectable()
export class RevisionStatusEffets {

    //////////////////////////
    // GET REVISION STATUS //
    ////////////////////////

    // Get Revision Status
    getRevisionStatus$ = createEffect(() =>
        this.actions$.pipe(
            ofType(RevisionStatusActions.getRevisionStatus), 
            mergeMap(() => {
            return this.revisionStatusService.getRevisionStatusGlobal({pageNumber: 0, pageSize: 25}).pipe(
                map((response) => 
                    RevisionStatusActions.getRevisionStatusSuccess({ revisionStatus: response.data })
                ), 
                catchError((error) =>
                    of(RevisionStatusActions.getRevisionStatusFailure({ error: error.message }))
                )
            );
        }),
        take(1)
        )
    );

    // Get Revision Status by id
    getRevisionStatusById$ = createEffect(() =>
        this.actions$.pipe(
            ofType(RevisionStatusActions.getRevisionStatusById), 
            mergeMap((action) => {
            return this.revisionStatusService.getRevisionStatusById(action.id).pipe(
                map((response) => 
                    RevisionStatusActions.getRevisionStatusByIdSuccess({ revisionStatus: response })
                ), 
                catchError((error) =>
                    of(RevisionStatusActions.getRevisionStatusByIdFailure({ error: error.message }))
                )
            );
        })
        )
    );




    /////////////////////////////
    // CREATE REVISION STATUS //
    ///////////////////////////

    // Create Revision Status
    createRevisionStatus$ = createEffect(() =>
      this.actions$.pipe(
          ofType(RevisionStatusActions.createRevisionStatus),
          mergeMap((action) => 
              this.revisionStatusService.createRevisionStatus(action.revisionStatus).pipe(
                  map((revisionStatus: IGetRevisionStatusResponse) => RevisionStatusActions.createRevisionStatusSuccess({ revisionStatus })),
                  catchError((error) => of(RevisionStatusActions.createRevisionStatusFailure({ error: error.message })))
              )
          )
      )
    );

    // Revision Status created successfully
    createRevisionStatusSuccess$ = createEffect(() => 
        this.actions$.pipe(
            ofType(RevisionStatusActions.createRevisionStatusSuccess),
            tap(() => {
                this.appnotificationService.notification$.next({ message:translate('settings.revisionStatus.createSuccess'), style: 'success' });
            })
        ), { dispatch: false }
    );

    // Revision Status not created successfully
    createRevisionStatusFailure$ = createEffect(() => 
      this.actions$.pipe(
          ofType(RevisionStatusActions.createRevisionStatusFailure),
          tap(() => {
          })
      ), { dispatch: false }
    );




    /////////////////////////////
    // UPDATE REVISION STATUS //
    ///////////////////////////

    // Update Revision Status
    updateRevisionStatus$ = createEffect(() =>
        this.actions$.pipe(
            ofType(RevisionStatusActions.updateRevisionStatus),
            mergeMap((action) => 
                this.revisionStatusService.updateRevisionStatus(action.revisionStatus).pipe(
                    map((revisionStatus: IGetRevisionStatusResponse) => RevisionStatusActions.updateRevisionStatusSuccess({ revisionStatus })),
                    catchError((error) => of(RevisionStatusActions.updateRevisionStatusFailure({ error: error.message })))
                )
            )
        )
    );
  
    // Update Revision Status successful
    updateRevisionStatusSuccess$ = createEffect(() => 
        this.actions$.pipe(
            ofType(RevisionStatusActions.updateRevisionStatusSuccess),
            tap(() => {
                this.appnotificationService.notification$.next({ message:translate('settings.revisionStatus.updateSuccess'), style: 'success' });
            })
        ), { dispatch: false }
    );
  
    // Revision Status not updated successfully
    updateRevisionStatusFailure$ = createEffect(() => 
        this.actions$.pipe(
            ofType(RevisionStatusActions.updateRevisionStatusFailure),
            tap(() => {
            })
        ), { dispatch: false }
    );




    /////////////////////////////
    // DELETE REVISION STATUS //
    ///////////////////////////

    // Delete Revision Status
    deleteRevisionStatus$ = createEffect(() =>
        this.actions$.pipe(
            ofType(RevisionStatusActions.deleteRevisionStatus), 
            mergeMap((action) => {
                return this.revisionStatusService.deleteRevisionStatus(action.id).pipe(
                    map(() => RevisionStatusActions.deleteRevisionStatusSuccess({id: action.id})), 
                    catchError((error) => of(RevisionStatusActions.deleteRevisionStatusFailure({ error: error })))
            )}
        ))
    );

    // Revision Status deleted successfully
    deleteRevisionStatusSuccess$ = createEffect(() => 
      this.actions$.pipe(
          ofType(RevisionStatusActions.deleteRevisionStatusSuccess),
          tap(() => {
              this.appnotificationService.notification$.next({ message:translate('settings.revisionStatus.deleteSuccess'), style: 'success' });
          })
      ), { dispatch: false }
    );




    constructor(
        private actions$: Actions, 
        private revisionStatusService: RevisionStatusService,
        private appnotificationService: AppNotificationService) {}
}